import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar_options.component";
import BottomBar from "../common_components/bottom_bar_options.component";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import axiosConfig from "../axiosConfig";
import StripePaymentForm from "../common_components/stripe/index";
import SubscriptionCard from "../common_components/subscribe/subscribeCard";
import { Card, CardContent } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import numberFormat from "../common_components/numberFormat";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Route, Redirect } from "react-router-dom";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    boxShadow: 3,
    width: "100%",
    "@media (min-width:100px)": {
      marginLeft: theme.spacing(10),
    },
    "@media (min-width:875px)": {
      marginLeft: theme.spacing(20),
    },
    "@media (min-width:1000px)": {
      marginLeft: theme.spacing(25),
    },
  },
  payBox: {
    minWidth: 275,
    borderColor: "#e0e0e0",
    borderWidth: 1,
    border: "solid",
    boxShadow: 0,
  },
  planTitle: {
    fontSize: 24,
    fontWeight: "800",
    color: "#000",
    textAlign: "left",
    fontFamily: "Open Sans",
  },
  planTitleSmall: {
    fontSize: 18,
    fontWeight: "800",
    color: "#000",
    textAlign: "left",
    fontFamily: "Open Sans",
  },
  priceTitle: {
    fontSize: 16,
    marginTop: "2%",
    fontWeight: "600",
    color: "#e64388",
    textAlign: "left",
    fontFamily: "Open Sans",
    marginBottom: "3%",
  },
  bottom_grid: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: "8%",
    height: 40,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
});

class Subscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      trial: false,
      startDate: "",
      subs: "",
      endDate: "",
      loading: true,
      open: false,
      selectedPlan: undefined,
      message: "You have successfully been subscribed",
      newSub: false,
    };
    this.setPlan = this.setPlan.bind(this);
    let brand_id = sessionStorage.getItem("brand_id");
    if (!brand_id) {
      this.props.history.push("/login");
    } else {
      this.loadData(brand_id);
    }
  }

  loadData(brand_id) {
    this.setState({
      loading: true,
    });
    axiosConfig
      .get(`/brand/stripe/checkSubscription/${brand_id}`)
      .then((res) => {
        // console.log(res);
        if (res.data.customer.length > 0) {
          const startDate = new Date(
            res.data.customer[0].current_period_start * 1000
          );
          const endDate = new Date(
            res.data.customer[0].current_period_end * 1000
          );
          this.setState({
            data: res.data.customer[0],
            startDate: startDate.toDateString(),
            endDate: endDate.toDateString(),
            subs: res.data.customer[0].plan.nickname,
            loading: false,
            trial: res.data.customer[0].status,
          });
        } else {
          this.setState({
            newSub: true,
            loading: false,
          });
        }
      })
      .catch((error) => {
        window.location.reload();
        // console.log("Error in api ", error);
        // console.log("Error in api ", error.response);
      });
  }

  componentWillMount() {
    document.title = "About Brand | CanaWho";
  }

  setPlan = (plan) => {
    // console.log("Plan", plan);
    this.setState({ selectedPlan: plan });
  };

  paymentResult = (result) => {
    if (result.data.success === false) {
      // Show error to your customer (e.g., insufficient funds)
      // console.log(result.data.error);
      this.setState({
        message: `There was an error while paying for the subscription. Message - ${result.data.error}`,
      });
      this.handleClickOpen();
    } else {
      this.handleClickOpen();
      // console.log("Result", result);
      window.location.reload();
    }
  };

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  cancelSub = () => {
    // console.log("i'm here");
    const brand_id = sessionStorage.getItem("brand_id");
    const sendData = {
      subscriptionId: this.state.data.id,
      brandId: brand_id,
    };
    // console.log("sub id ", sendData);
    axiosConfig
      .delete(`/brand/stripe/subscription/`, { data: sendData })
      .then((res) => {
        // console.log("sub id ", res.data);
        if (res.data.success) {
          alert("Subscription cancelled");
          this.loadData(brand_id);
          window.location.reload();
        } else {
          alert("Facing problem when cancelling a subscription");
        }
      })
      .catch((error) => {
        // console.log("Error in api ", error);
        // console.log("Error in api ", error.response);
      });
  };

  render() {
    const { classes } = this.props;
    const {
      selectedPlan,
      open,
      loading,
      data,
      startDate,
      endDate,
      trial,
      message,
      newSub,
      subs,
    } = this.state;

    return (
      <div className={classes.root}>
        <TopAppBar disabled={data === null ? true : false} />
        {loading ? (
          <Grid
            container
            justify="center"
            alignContent="center"
            style={{ minHeight: "100vh" }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container justify="center">
            {newSub ? null : (
              <Grid container>
                <Grid item className={classes.paper}>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ color: "#F6277F", fontFamily: "Open Sans" }}
                  >
                    SUBSCRIPTION
                  </Typography>
                  <Typography
                    variant="h5"
                    style={{
                      color: "#000",
                      fontFamily: "Open Sans",
                      marginTop: "8%",
                      fontWeight: "bold",
                    }}
                  >
                    Your Plan
                  </Typography>
                  {trial === "trialing" ? (
                    <Typography
                      variant="h6"
                      style={{
                        color: "#000",
                        fontFamily: "Open Sans",
                        margin: "2%",
                      }}
                    >
                      <br />
                      <b>
                        You have signed up for an {subs} for
                        {` $${numberFormat(
                          data.plan.amount / 100
                        )} CAD + tax per year`}
                      </b>
                      <br />
                      <br />
                      <b>Current Billing Cycle </b>
                      <br />
                      <b>Started Date - </b>
                      {startDate}
                      <br />
                      <b>Next billing Date - </b>
                      {endDate}
                    </Typography>
                  ) : (
                    <Typography
                      variant="h6"
                      style={{
                        color: "#000",
                        fontFamily: "Open Sans",
                        margin: "2%",
                      }}
                    >
                      You have signed up for an {subs} for
                      {` $${numberFormat(
                        data.plan.amount / 100
                      )} CAD + tax per year`}
                      <br />
                      <b>Started On - </b>
                      {startDate}
                      <br />
                      <b>Next billing On - </b>
                      {endDate}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            )}
            {newSub ? (
              <Container
                maxWidth="md"
                style={{
                  marginTop: "5%",
                  marginBottom: "5%",
                }}
              >
                <Card>
                  <CardContent style={{ marginBottom: "5%" }}>
                    <SubscriptionCard updatePlan={this.setPlan.bind(this)} />
                    <Grid container alignItems="center" justify="center">
                      <Card elevation={0} className={classes.payBox}>
                        <CardContent style={{ marginBottom: "5%" }}>
                          <Typography className={classes.planTitle}>
                            Enter your card details.
                          </Typography>
                          {selectedPlan === undefined ? null : (
                            <Grid>
                              <Typography className={classes.priceTitle}>
                                You are purchasing{" "}
                                {`${
                                  this.capitalizeFirstLetter(
                                    selectedPlan.interval
                                  ) === "Year"
                                    ? "an Annual"
                                    : "a Monthly"
                                }`}{" "}
                                Subscription for{" "}
                                {`$${numberFormat(
                                  selectedPlan.amount / 100
                                )} CAD`}{" "}
                                + tax that will be charged to your account{" "}
                                {`${
                                  this.capitalizeFirstLetter(
                                    selectedPlan.interval
                                  ) === "Year"
                                    ? "annually"
                                    : "monthly"
                                }`}
                                .
                              </Typography>
                              <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justify="center"
                              >
                                <StripePaymentForm
                                  planId={selectedPlan}
                                  paymentResult={this.paymentResult.bind(this)}
                                />
                              </Grid>
                            </Grid>
                          )}
                          <Typography className={classes.planTitleSmall}>
                            If you do not cancel your subscription before the
                            trial period ends, you agree that you will
                            automatically be charged the subscription fee until
                            you cancel.
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </CardContent>
                </Card>
              </Container>
            ) : null}
            {newSub ? null : (
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{ width: "50%", marginBottom: "10%" }}
              >
                <Button
                  style={{
                    width: "100%",
                    height: 40,
                    marginTop: "5%",
                    backgroundColor: "#F6277F",
                    boxShadow: "2",
                  }}
                  onClick={() => this.cancelSub()}
                >
                  <Typography
                    style={{
                      color: "#FFF",
                      fontWeight: "500",
                      fontFamily: "Open Sans",
                      fontSize: 14,
                      textTransform: "none",
                    }}
                  >
                    Cancel Subscription
                  </Typography>
                </Button>
              </Grid>
            )}
            <Dialog
              open={open}
              onClose={() => this.handleClose()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Subscription Status"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => this.handleClose()}
                  color="primary"
                  autoFocus
                >
                  Okay
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}
        <BottomBar />
      </div>
    );
  }
}

Subscription.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Subscription);
